import React, { useState } from 'react';

export default function DateTimePicker({ props: p, onAction, partId, disabled, dir }) {
  const [date, setDate] = useState(p.date || '');
  const [time, setTime] = useState(p.time || '');

  return (
    <div className="ui-datetime-picker" dir={dir}>
      {p.title && <div className="ui-part-title">{p.title}</div>}
      <input type="date" value={date} disabled={disabled} onChange={(e) => setDate(e.target.value)} />
      <input type="time" value={time} disabled={disabled} onChange={(e) => setTime(e.target.value)} />
      <button
        type="button"
        className="ui-btn primary"
        disabled={disabled}
        onClick={() =>
          onAction?.({
            actionId: 'form.submit',
            mode: 'turn',
            payload: { values: { date_utc: date, time_utc: time } },
            partId,
          })
        }
      >
        Apply
      </button>
    </div>
  );
}
